let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("4jVs5")).then(() => parcelRequire('hwHW3'));